<div class="container m-2 p-3">
  <form novalidate class="form-inline" [formGroup]="searchForm">
    <div class="form-group row justify-content-center">
      <!-- Autocomplete and button row -->
      <div class="col-12 col-md-12 notMobile">
        <div class="d-flex align-items-center">

          <!-- Autocompelte Component -->
          <span class="p-fluid flex-grow-1">
            <p-autoComplete inputId="keywords"
              placeholder="Enter Search Term(s) to Search - Searches Content & Properties" formControlName="keywords"
              id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500" [showClear]="true"
              (onClear)="clearKeyword()" [suggestions]="aSugs" (completeMethod)="getSuggestions($event)"
              (onSelect)="kwSuggestionSelected($event)">
              <ng-template let-item pTemplate="item">
                <div pTooltip="{{ item }}" tooltipPosition="top">{{ item }}</div>
              </ng-template>
            </p-autoComplete>
            <!-- Error message for keyword length validation -->
            <div class="text-danger small mt-1" *ngIf="keywordLengthError">
              Please enter at least 3 characters or leave the field empty.
            </div>
          </span>

          <!-- Search Button -->
          <button type="submit" class="btn btn btn-secondary ms-2" (click)="submitForm();"
            [disabled]="!searchForm.valid">
            <i class="fas fa-search"></i> Search
          </button>
        </div>
      </div>
      <!-- MOBILE - Autocomplete and button row -->
      <div class="col-sm-12 forMobile">
        <div class="">

          <!-- Autocompelte Component -->
          <div class="p-fluid flex-grow-1">
            <p-autoComplete inputId="keywords" placeholder="Enter Keywords/Phrases to Search" formControlName="keywords"
              id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500" [showClear]="true"
              [suggestions]="aSugs" (completeMethod)="getSuggestions($event)" (onSelect)="kwSuggestionSelected($event)">
              <ng-template let-item pTemplate="item">
                <div pTooltip="{{ item }}" tooltipPosition="top">{{ item }}</div>
              </ng-template>
            </p-autoComplete>
            <!-- Error message for keyword length validation -->
            <div class="text-danger small mt-1" *ngIf="keywordLengthError">
              Please enter at least 3 characters or leave the field empty.
            </div>
          </div>

          <!-- Search Button -->
          <div class="col-12 mt-2" style="text-align: center;">
            <button type="submit" class="btn btn btn-secondary ps-5 pe-5 mt-2" (click)="submitForm();"
              [disabled]="!searchForm.valid">
              <i class="fas fa-search"></i> Search
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
